import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {Broderkort} from './models/broderkort';
import {Forlaning} from './models/hc';
import {AktiviteterService} from './aktiviteter.service';
import {Tilldelningar} from './models/tilldelningar';

export interface TilldelningModel {
    broderkort: Broderkort;
    redan_tilldelat: Forlaning[];
}

@Component({
    selector: 'app-tilldelning',
    templateUrl: './tilldelning.component.html',
    styles: []
})
export class TilldelningComponent extends DialogComponent<TilldelningModel, Forlaning> implements TilldelningModel, OnInit {
    broderkort: Broderkort;
    redan_tilldelat: Forlaning[];
    tilldelningar: Tilldelningar;

    constructor(dialogService: DialogService, private aktiviteterService: AktiviteterService) {
        super(dialogService);
    }

    ngOnInit(): void {
        this.aktiviteterService.getTilldelningar().then(result => this.tilldelningar = result);
    }

    tilldela(forlaning: Forlaning, hc: boolean = null) {
        this.result = forlaning;
        this.result.hc = hc;
        this.close();
    }

    tilldelaPersonligVardighet() {
        const title = prompt('Ange titel:');
        this.result = {
            desc: 'Den personliga värdigheten ' + title,
            type: 'personligavardigheter',
            short: title,
            id: null,
            hc: null,
            confirmed: null
        };
        this.close();
    }

    selectPermanent(event: Event) {
        const index = (event.target as HTMLSelectElement).value;
        const hc = this.tilldelningar.medaljer.permanenta[index];
        this.tilldela(hc);
    }

    selectTemp(event: Event) {
        const index = (event.target as HTMLSelectElement).value;
        const hc = this.tilldelningar.medaljer.temporary[index];
        this.tilldela(hc);
    }

    selectFelicitas(event: Event) {
        const index = (event.target as HTMLSelectElement).value;
        const hc = this.tilldelningar.medaljer.felicitas[index];
        this.tilldela(hc);
    }

    selectHusorden(event: Event) {
        const index = (event.target as HTMLSelectElement).value;
        const hc = this.tilldelningar.medaljer.husordnar[index];
        this.tilldela(hc);
    }
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/tilldelning.component.ts